import { Link } from "react-router-dom";
import { BUSINESS_INFO_FIELDS, BUSINESS_NAME } from "@makit/shared";

import { PUBLIC_PATHS } from "../screens/public/paths";

/** 사업자 정보. **모든 웹 화면 맨 아래에 같은 블록이 선다**(PRD `7.0` 「로그인 전 화면」 공통 요소).
 *
 * 로그인 전 화면(`P-01`~`P-04`) · 로그인(`W-01` · `W-01b` · `W-01c`) · 로그인 뒤 셀러 콘솔 전부다.
 * 결제사 심사가 **모든 화면 하단**을 요구해서 한 자리라도 빠지면 그 캡처가 걸린다. 그래서
 * 화면마다 그리지 않고 `App.tsx` 가 라우트 바깥에 한 번 둔다.
 *
 * **값은 이 파일에 없다.** 상호와 일곱 칸은 `packages/shared/src/public-copy.ts` 한 곳에서만
 * 온다. 지금은 전부 목업의 자리 표시이고 지어내지 않았다. ⛔ 자리 표시를 단 채로 게시하지
 * 않는다(법무 `L-F54`). 값 채우기는 그 파일 한 곳에서 한다.
 *
 * 낱말은 `사업자 정보` 다. `판매자 정보` 라고 하면 셀러가 자기 정보로 읽는다(PRD `7.5.9`).
 * 링크 줄에서 **개인정보처리방침만 굵게** 둔다. 다른 고지와 구분해 쉽게 찾게 하는 관행이다
 * (목업 `P-04` 캡션). */
export function BusinessInfo() {
  return (
    <footer className="bizinfo" aria-label="사업자 정보">
      <div className="bizinner">
        <nav className="bizlinks" aria-label="약관과 정책">
          <Link to={PUBLIC_PATHS.terms}>이용약관</Link>
          <Link to={PUBLIC_PATHS.privacy}>
            <b>개인정보처리방침</b>
          </Link>
          <Link to={PUBLIC_PATHS.refund}>환불정책</Link>
        </nav>
        <span className="bizname mono">{BUSINESS_NAME}</span>
        <span className="bizrows">
          {BUSINESS_INFO_FIELDS.map((field) => (
            <span key={field.label}>
              {field.label} <span className="mono">{field.value}</span>
            </span>
          ))}
        </span>
      </div>
    </footer>
  );
}
